/* eslint-env node */
// Logika MURNI untuk "Log Aktivitas Akun AHU".
// Sengaja TANPA import Vuex/Vue agar bisa diuji dengan Node biasa
// (lihat src/helpers/__tests__/ahuLogger.test.js). Dipakai oleh ahuLogger.js.

// Peta path rute -> label menu yang ramah dibaca (kolom "Data" pada halaman log).
var MENU_LABELS = {
  '/dashboard': 'Dashboard',
  '/konten': 'Konten',
  '/pelaporan': 'Pelaporan',
  '/pelaporan/riwayat': 'Riwayat Pelaporan',
  '/permohonan': 'Permohonan',
  '/perubahan-profil': 'Perubahan Profil',
  '/draft': 'Draft',
  '/ormas': 'Data Ormas',
  '/profile': 'Informasi Ormas',
  '/profile/data-organisasi': 'Data Organisasi',
  '/profile/cabang-organisasi': 'Cabang Organisasi',
  '/formdataormas': 'Form Data Ormas',
  '/info-ormas/domisili': 'Domisili',
  '/info-ormas/nasional': 'Nasional',
  '/info-ormas/rekap-organisasi': 'Rekap Organisasi',
  '/rekap-organisasi': 'Rekap Organisasi',
  '/tata-kelola/permohonan': 'Persetujuan Permohonan',
  '/tata-kelola/cabang-terdaftar': 'Cabang Terdaftar',
  '/tata-kelola/cabang-lapor': 'Cabang Lapor',
  '/tata-kelola/sengketa': 'Sengketa',
  '/tata-kelola/tambah-ormas': 'Tambah Ormas',
  '/tata-kelola/tambah-ormas-asing': 'Tambah Ormas Asing',
  '/pengaturan/konten/kategori': 'Pengaturan Kategori Konten',
  '/pengaturan/konten/cms': 'Pengaturan CMS',
  '/pengaturan/pengguna/tambah-pengguna': 'Kelola Pengguna',
  '/pengaturan/pengguna/instansi': 'Kelola Instansi',
  '/pengaturan/pengguna/hakakses': 'Kelola Hak Akses',
  '/pengaturan/pengguna/pembekuan': 'Kelola Pembekuan Ormas',
  '/pengaturan/pengguna/usertype': 'Kelola Usertype',
  '/pengaturan/datamaster/cirikhusus': 'Data Master Ciri Khusus',
  '/pengaturan/datamaster/bidangkegiatan': 'Data Master Bidang Kegiatan',
  '/pengaturan/datamaster/kegiatan': 'Data Master Kegiatan',
  '/pengaturan/datamaster/jenissekretariat': 'Data Master Jenis Sekretariat',
  '/pengaturan/datamaster/wilayah': 'Data Master Wilayah',
  '/pengaturan/log-aktivitas': 'Log Aktivitas Akses Ormas Badan Hukum',
  '/pengaturan/log-aktivitas-ahu': 'Log Aktivitas Akun AHU'
};

// Label menu dari path. Cocok persis dulu, lalu prefix terpanjang untuk rute anak/detail.
function menuLabel(path) {
  if (!path) return '-';
  if (MENU_LABELS[path]) return MENU_LABELS[path];
  var best = '';
  Object.keys(MENU_LABELS).forEach(function(k) {
    if (path.indexOf(k) === 0 && k.length > best.length) best = k;
  });
  return best ? MENU_LABELS[best] : path;
}

/**
 * Bangun payload aktivitas AHU, atau null bila tidak boleh dicatat.
 * GUARD backward-compat: mengembalikan null kecuali user.is_ahu === true.
 * @param {object} user  objek user (localStorage 'user').
 * @param {string} kind  'menu' | 'detail' | 'search' | 'download' | 'export'.
 * @param {object} opts  { label, entitas, waktu }.
 * @returns {object|null}
 */
function buildAhuActivity(user, kind, opts) {
  opts = opts || {};
  if (!user || user.is_ahu !== true || !user.id) return null;

  var nama = user.nama_lengkap || user.username || '-';
  var roleName = (user.roles_full && user.roles_full[0] && user.roles_full[0].role_name) || '-';
  var waktu = opts.waktu || '';
  var dataLabel;
  var actionLabel;
  var activity;

  if (kind === 'menu') {
    dataLabel = opts.label || '-';
    actionLabel = 'Membuka menu';
    activity = nama + ' membuka menu ' + dataLabel + ' pada ' + waktu;
  } else {
    var entitas = opts.entitas != null ? String(opts.entitas).trim() : '';
    if (!entitas) return null; // jangan spam log untuk aksi tanpa kata kunci/nama
    dataLabel = entitas;
    if (kind === 'search') {
      actionLabel = 'Pencarian';
      activity = nama + ' mencari ' + entitas + ' pada ' + waktu;
    } else if (kind === 'download' || kind === 'export') {
      actionLabel = 'Mengunduh';
      activity = nama + ' mengunduh ' + entitas + ' pada ' + waktu;
    } else {
      // detail / default
      actionLabel = 'Membuka';
      activity = nama + ' membuka detail ' + entitas + ' pada ' + waktu;
    }
  }

  return {
    user_id: String(user.id),
    activity: activity,
    category: 'AHU_ACCESS',
    role_name: roleName,
    nama_lengkap: nama,
    action_label: actionLabel,
    data_label: dataLabel
  };
}

module.exports = {
  MENU_LABELS: MENU_LABELS,
  menuLabel: menuLabel,
  buildAhuActivity: buildAhuActivity
};
